// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-27T06:56:37Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro sign_Timestamp_Level.
 */
enum EnumSignTimestampLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED', 
    NONE = 'NONE'
};
export default EnumSignTimestampLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSignTimestampLevel.QUALIFIED]: {caption: ''},
    [EnumSignTimestampLevel.GUARANTEED]: {caption: ''},
    [EnumSignTimestampLevel.NONE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
